/**
 * Auth constants for the web app (hardcoded).
 * Keep GOOGLE_CLIENT_ID in sync with backend/auth_constants.js.
 */
export const GOOGLE_CLIENT_ID =
    '724405183597-qqmqnhdi2k7qd5m0u2de1b069etv333j.apps.googleusercontent.com';

export const PASSWORD_MIN_LENGTH = 8;

/** Options for client-readable cookies (terms flag, display profile). */
export function clientCookieOptions() {
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    return {
        path: '/',
        secure,
        sameSite: 'strict',
    };
}
